import { useContext, useState } from "react";
import { quoteContext } from "../../context/quotesContext";
import "./styles.css";
import { useTranslation } from "react-i18next";

const SummarOrderMobile = () => {
  const [t] = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { selectedProvider, createShipmentResponse } = useContext(quoteContext);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div className="shipping-cost-container-mobile">
      <div className="summary-header" onClick={toggleOpen}>
        <div className="summary-title">
          {isOpen ? "Costos de envío" : "Total"}
        </div>
        <div className="summary-value">
          {!isOpen && `$${selectedProvider?.total ||0 }`}

          <span className={`arrow ${isOpen ? "up" : "down"}`}></span>
        </div>
      </div>

      {isOpen && (
        <div className="summary-content-mobile">
          <div className="shipping-item-mobile">
            {t('freight')}
            <span>$ {selectedProvider.total_freight}</span>
          </div>
          <div className="shipping-item-mobile">
            {t('insurance_and_taxes')}
            <span>$ {selectedProvider.total_taxes_fees}</span>
          </div>
          <div className="shipping-item-mobile">
            {t('destination')}
            <span>{createShipmentResponse.city_to}</span>
          </div>
          <div className="shipping-item-mobile">
            {t('delivery_time')}
            <span>{selectedProvider.estimated_days}</span>
          </div>
          <div className="split-divide-mobile"></div>
          <div className="shipping-item-mobile total-mobile">
            {t('Total')}
           
            <span>${selectedProvider?.total  || 0}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export { SummarOrderMobile };
